const HOST: string = process.env.HOST_URL
const PORT: number = parseInt(process.env.app_port, 10)

const isProd = process.env.NODE_ENV === 'production'

const hostURL = isProd ? `${HOST}` : `${HOST}:${PORT}`

export const SVGPath: string = hostURL + '/public/energyhouse.svg'
